import { TrendingDown, TrendingUp } from 'lucide-react';
import { clsx } from 'clsx';

import styles from './recent-transactions.module.css';

export function TransactionItem({ transaction }) {
	const { type, icon, category, date, amount, currency } = transaction;
	const isIncome = type === 'Income';
	const TrendIcon = isIncome ? TrendingUp : TrendingDown;

	return (
		<div className={styles.item}>
			<div className={styles.left}>
				<img src={icon} alt={category} className={styles.icon} />
				<div>
					<div className={styles.title}>{category}</div>
					<div className={styles.date}>{date}</div>
				</div>
			</div>
			<div
				className={clsx(
					styles.amount,
					isIncome ? styles.income : styles.expense,
				)}
			>
				<span>
					{isIncome ? '+' : '-'}
					{amount} {currency || '$'}
				</span>
				<TrendIcon size={16} />
			</div>
		</div>
	);
}
